import gql from "graphql-tag";

/**
 * GraphQL Mutations for user creation
 */

 const PortUserMutation = gql`
mutation($input: PortUserCreationInput!) {
    CreatePortUser(input: $input) {
      full_name
    }
  }
 `


 const NimasaUserMutation = gql`
mutation($input: NimasaUserCreationInput!) {
    CreateNimasaUser(input: $input) {
      full_name
    }
  }
 `

const NimasaAdminUserMutation = gql`
  mutation($input: NimasaAdminUserCreationInput!) {
    CreateNimasaAdminUser(input: $input) {
      full_name
    }
  }
`;

 export default {
     NimasaAdminUserMutation, NimasaUserMutation,
     PortUserMutation
 }
